import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReceiptDefault = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 68,
	height: 68,
	viewBox: "0 0 68 68",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 1,
			width: 67,
			height: 67,
			rx: 4,
			fill: "#111010"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M30.2372 17.9082L28.7484 22.1262C28.7128 22.2272 28.7495 22.3397 28.838 22.4002L32.5995 24.9714C32.6645 25.0158 32.7032 25.0898 32.7025 25.1686L32.6613 30.0312C32.6592 30.2812 32.9959 30.3631 33.1088 30.14L36.5713 23.3027C36.6264 23.194 36.5898 23.0612 36.4867 22.996L33.9022 21.3611C33.7891 21.2896 33.7578 21.1385 33.8333 21.0279L35.9625 17.9082H38.5657C39.0207 17.9082 39.4534 18.1047 39.7528 18.4472L42.639 21.7485L46.0884 25.6851C46.3404 25.9726 46.4793 26.3419 46.4793 26.7242V48.52C46.4793 49.3908 45.7733 50.0967 44.9025 50.0967H23.0975C22.2267 50.0967 21.5208 49.3908 21.5208 48.52V19.485C21.5208 18.6141 22.2267 17.9082 23.0975 17.9082H30.2372Z",
			fill: "#808080"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 24.933,
			y1: 28.9027,
			x2: 30.7098,
			y2: 28.9027,
			stroke: "#979797",
			strokeWidth: .788381,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 24.9328,
			y1: 30.6722,
			x2: 30.7096,
			y2: 30.6722,
			stroke: "#979797",
			strokeWidth: .788381,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsxs("mask", {
			id: "mask0_10264_41965",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 21,
			y: 17,
			width: 26,
			height: 34,
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M42.3422 22.008L42.3425 22.0083L45.7919 25.9449C45.9809 26.1605 46.0851 26.4375 46.0851 26.7242V48.52C46.0851 49.1731 45.5556 49.7025 44.9025 49.7025H23.0975C22.4444 49.7025 21.9149 49.1731 21.9149 48.52V19.485C21.9149 18.8319 22.4444 18.3024 23.0975 18.3024H38.5657C38.9069 18.3024 39.2315 18.4498 39.4561 18.7066L42.3422 22.008Z",
					fill: "#64748B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M42.3422 22.008L42.3425 22.0083L45.7919 25.9449C45.9809 26.1605 46.0851 26.4375 46.0851 26.7242V48.52C46.0851 49.1731 45.5556 49.7025 44.9025 49.7025H23.0975C22.4444 49.7025 21.9149 49.1731 21.9149 48.52V19.485C21.9149 18.8319 22.4444 18.3024 23.0975 18.3024H38.5657C38.9069 18.3024 39.2315 18.4498 39.4561 18.7066L42.3422 22.008Z",
					stroke: "black",
					strokeWidth: .788381
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M42.3422 22.008L42.3425 22.0083L45.7919 25.9449C45.9809 26.1605 46.0851 26.4375 46.0851 26.7242V48.52C46.0851 49.1731 45.5556 49.7025 44.9025 49.7025H23.0975C22.4444 49.7025 21.9149 49.1731 21.9149 48.52V19.485C21.9149 18.8319 22.4444 18.3024 23.0975 18.3024H38.5657C38.9069 18.3024 39.2315 18.4498 39.4561 18.7066L42.3422 22.008Z",
					stroke: "black",
					strokeOpacity: .2,
					strokeWidth: .788381
				})
			]
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_10264_41965)",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 39.0955,
				y: 2.14258,
				width: 23.9672,
				height: 23.9672,
				rx: 1.57676,
				fill: "#565656"
			})
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 26.7165,
			y1: 36.0394,
			x2: 41.0362,
			y2: 36.0394,
			stroke: "#979797",
			strokeWidth: .788381,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 26.7165,
			y1: 41.8929,
			x2: 41.0362,
			y2: 41.8929,
			stroke: "#979797",
			strokeWidth: .788381,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 26.7165,
			y1: 38.9652,
			x2: 41.0362,
			y2: 38.9652,
			stroke: "#979797",
			strokeWidth: .788381,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 26.7169,
			y1: 44.8207,
			x2: 41.0367,
			y2: 44.8207,
			stroke: "#979797",
			strokeWidth: .788381,
			strokeLinecap: "round"
		})
	]
});
export default SvgReceiptDefault;
